import React from 'react';
import BlockGroupingOne from './BlockGroupingOne';
import BlockGroupingOneTwo from './BlockGroupingOneTwo';
import BlockGroupingTwoOne from './BlockGroupingTwoOne';
import BlockGroupingOneOne from './BlockGroupingOneOne';

function ImageGroupComponent({
  blockGroup,
}: {
  blockGroup: {
    blocks: { block1: object; block2: object; block3: object };
    blockType: string;
  };
}) {
  return (
    <>
      {blockGroup.blockType === '1' && (
        <BlockGroupingOne blocks={blockGroup.blocks} />
      )}
      {blockGroup.blockType === '1-1' && (
        <BlockGroupingOneOne blocks={blockGroup.blocks} />
      )}
      {blockGroup.blockType === '1-2' && (
        <BlockGroupingOneTwo blocks={blockGroup.blocks} />
      )}
      {blockGroup.blockType === '2-1' && (
        <BlockGroupingTwoOne blocks={blockGroup.blocks} />
      )}
    </>
  );
}

export default ImageGroupComponent;
